// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router';
import vMediaQuery from 'v-media-query';
import VueGtag from 'vue-gtag';
import Meta from 'vue-meta';
import gallery from 'img-vuer';

import App from './App'
import router from './router'
import store from './store'

window.$ = window.jQuery = require('jquery'); //
require('bootstrap-sass');
require('./assets/sass/styles.scss');

window.Vue = Vue;
Vue.use(VueRouter);
Vue.use(vMediaQuery);
Vue.use(Meta);
Vue.use(gallery, {
    swipeThreshold: 50, // default 100
    isIndexShow: false, // show image index, default true
    useCloseButton: false, // trigger gallery close with close button, default true
    preload: false // preload images in the same group, default true
});

/* global IS_PROD_MODE */
if (IS_PROD_MODE) {
    /* global FRS_GA_TRACKING_ID */
    /* global FRS_GAW_ID */
    Vue.use(VueGtag, {
        config: { id: FRS_GA_TRACKING_ID },
        includes: [
            { id: FRS_GAW_ID }
        ]
    }, router);
}

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js